import { render, staticRenderFns } from "./AddCouponRule.vue?vue&type=template&id=557be13c&scoped=true"
import script from "./AddCouponRule.vue?vue&type=script&lang=js"
export * from "./AddCouponRule.vue?vue&type=script&lang=js"
import style0 from "./AddCouponRule.vue?vue&type=style&index=0&id=557be13c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557be13c",
  null
  
)

export default component.exports